import React from 'react';
import { useForm } from 'react-hook-form';

import { Title, IntroText, InputText, Container, Button, Form } from './styled';

export function ErrorFallback({ err, resetErrorBoundary }) {
  const { register, handleSubmit } = useForm();

  const onSubmit = (data) => {
    alert(data);
  };

  return (
    <Container>
      <Title>Oeps, er gaat iets fout.</Title>
      <Button onClick={resetErrorBoundary}>Log opnieuw in</Button>
      <IntroText>
        Helaas ging er iets fout in onze spelomgeving. Stuur ons een bericht via
        het onderstaande contactformuslier. Voeg uw naam en uw inlogcode toe aan
        het bericht. En wij nemen contact met u op.
      </IntroText>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <InputText
          type='text'
          placeholder='LoginCode'
          name='LoginCode'
          ref={register({
            required: true,
            max: 16,
            min: 8,
            message: 'Invullen van een bericht is verplicht',
            maxLength: 240,
          })}
        />
        <input
          type='text'
          placeholder='secure'
          name='secureCode'
          className='secureCode'
          ref={register({ required: false })}
        />
        <Button type='submit'>Verzenden</Button>
      </Form>
    </Container>
  );
}
